import React from "react";
interface props {
  className?: string;
}
function InstagramSvg({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      className={className}
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#fff"
        d="M11.257 2.21a69.96 69.96 0 011.774.02l.157.005.577.025c.862.04 1.45.176 1.967.376.535.206.985.485 1.436.935.412.405.73.895.934 1.436.2.516.336 1.104.377 1.967.01.215.018.395.024.577l.005.157c.012.399.017.861.019 1.773v1.666c.002.591-.004 1.182-.018 1.773l-.005.157-.024.577c-.04.863-.179 1.45-.378 1.968a3.972 3.972 0 01-.934 1.436 3.97 3.97 0 01-1.436.934c-.516.2-1.104.336-1.967.377l-.577.024-.157.005c-.4.011-.862.017-1.774.018l-.604.001h-1.06a63.568 63.568 0 01-1.775-.019l-.157-.004a50.488 50.488 0 01-.577-.025c-.862-.041-1.45-.177-1.967-.377a3.97 3.97 0 01-1.435-.934 3.97 3.97 0 01-.935-1.436c-.2-.517-.337-1.105-.377-1.968l-.024-.577-.004-.157a64.017 64.017 0 01-.02-1.773V9.481c-.003-.591.003-1.182.017-1.773l.006-.157c.006-.182.014-.362.024-.577.04-.863.177-1.45.377-1.967a3.97 3.97 0 01.937-1.436 3.97 3.97 0 011.434-.935c.517-.2 1.104-.336 1.967-.376l.577-.025.157-.005C8.41 2.216 9 2.21 9.591 2.212l1.666-.001zm-.833 4.052a4.052 4.052 0 100 8.104 4.052 4.052 0 000-8.104zm0 1.621a2.431 2.431 0 110 4.863 2.431 2.431 0 01.001-4.863m4.254-2.836a1.013 1.013 0 100 2.026 1.013 1.013 0 000-2.026z"
        opacity="0.8"
      ></path>
    </svg>
  );
}

export default InstagramSvg;
